import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialogViewModel from "./../factories/bao-dialog";
import BaoMenu from "./../services/bao-menu";
import SearchPaging from "./../factories/search-paging";
// bao migrate - module not found: import Synoset from "modules/synoset-module";
import "./../bindings/bao-number-box";
function TermOfPaymentViewModel(tabPage) {
    var self = this;
    SearchPaging.call(this, tabPage);
    self.CompleteCheck = function () {
        var isComplete = true;
        if (Bao.Utils.String.IsNullOrEmpty(self.Name())) {
            isComplete = false;
        }
        if (!isComplete) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    };
}
Bao.inherit(TermOfPaymentViewModel, SearchPaging);
TermOfPaymentViewModel.prototype.PrimaryKey = "TermOfPaymentId";
TermOfPaymentViewModel.prototype.RefreshUrl = "TermOfPayment/Get";
TermOfPaymentViewModel.prototype.SaveUrl = "TermOfPayment/Save";
TermOfPaymentViewModel.prototype.DeleteUrl = "TermOfPayment/Delete";
TermOfPaymentViewModel.prototype.IsInUseUrl = "TermOfPayment/IsInUse";
TermOfPaymentViewModel.prototype.PermissionForward = "TermOfPaymentMoveForwardSearch";
TermOfPaymentViewModel.prototype.PermissionBackward = "TermOfPaymentMoveBackwardSearch";
TermOfPaymentViewModel.prototype.PermissionSave = "TermOfPaymentSave";
TermOfPaymentViewModel.prototype.PermissionRefresh = "TermOfPaymentRefresh";
TermOfPaymentViewModel.prototype.PermissionDelete = "TermOfPaymentDelete";
export default TermOfPaymentViewModel;